<script setup lang="ts">
definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Integriteitsbeleid',
    subtitle: 'Onze normen en waarden voor integer en ethisch gedrag',
    icon: 'bx-check-shield',
    iconColor: 'success',
  },
})

const sections = [
  {
    title: '1. Inleiding',
    content: '\'t SpeelFabrik VZW hecht veel waarde aan integriteit en ethisch gedrag. Dit Integriteitsbeleid beschrijft de normen en waarden waaraan wij ons houden en die wij van onze medewerkers, partners en leveranciers verwachten.',
  },
  {
    title: '2. Kernwaarden',
    content: `Ons Integriteitsbeleid is gebaseerd op de volgende kernwaarden:

• Eerlijkheid: We zijn eerlijk en transparant in al onze handelingen
• Betrouwbaarheid: We doen wat we beloven en houden ons aan afspraken
• Respect: We behandelen iedereen met respect en waardigheid
• Professionaliteit: We handelen professioneel en met vakmanschap
• Verantwoordelijkheid: We nemen verantwoordelijkheid voor onze acties en beslissingen
• Transparantie: We communiceren open en duidelijk`,
  },
  {
    title: '3. Toepassingsgebied',
    content: `Dit Integriteitsbeleid is van toepassing op:
• Alle medewerkers en vrijwilligers van 't SpeelFabrik VZW
• Tijdelijke medewerkers en stagiairs
• Bestuurders
• Externe partners die namens ons optreden
• Leveranciers en onderaannemers waar relevant`,
  },
  {
    title: '4. Gedragsnormen',
    content: `4.1 Algemeen gedrag
We verwachten van al onze medewerkers dat zij:
• Integer handelen in alle zakelijke en professionele situaties
• De reputatie van de organisatie beschermen
• Zich houden aan alle toepasselijke wet- en regelgeving
• Respectvol omgaan met collega's, klanten en partners
• Professioneel en collegiaal gedrag vertonen

4.2 Belangenverstrengeling
Medewerkers moeten situaties vermijden waarin persoonlijke belangen in strijd kunnen komen met de belangen van de organisatie. Mogelijke belangenverstrengeling moet altijd worden gemeld.

4.3 Geschenken en uitnodigingen
Het aannemen van geschenken, gunsten of uitnodigingen is alleen toegestaan wanneer:
• De waarde bescheiden is (richtlijn: maximaal €50)
• Het geen invloed heeft op zakelijke beslissingen
• Het niet in strijd is met de wet of bedrijfsregels
• Het openlijk kan worden gedaan`,
  },
  {
    title: '5. Vertrouwelijke informatie',
    content: `5.1 Medewerkers gaan zorgvuldig om met vertrouwelijke informatie van de organisatie, klanten en partners.

5.2 Vertrouwelijke informatie mag niet:
• Worden gedeeld met onbevoegde personen
• Worden gebruikt voor persoonlijk gewin
• Worden gebruikt na beëindiging van het dienstverband

5.3 Dit geldt ook voor informatie verkregen via sociale media of informele gesprekken.`,
  },
  {
    title: '6. Financiële integriteit',
    content: `6.1 Alle financiële transacties worden nauwkeurig en tijdig geregistreerd volgens geldende administratieve voorschriften.

6.2 Fraude, corruptie en omkoping zijn strikt verboden.

6.3 Medewerkers die betrokken zijn bij financiële transacties moeten:
• Alleen legitieme zakelijke uitgaven declareren
• Declaraties voorzien van correcte bonnen en documentatie
• Zich houden aan het declaratiereglement
• Geen dubbele declaraties indienen

6.4 Het witwassen van geld is verboden en verdachte transacties moeten worden gemeld.`,
  },
  {
    title: '7. Discriminatie en intimidatie',
    content: `7.1 't SpeelFabrik VZW biedt een werkomgeving vrij van discriminatie en intimidatie.

7.2 Discriminatie op basis van de volgende gronden is verboden:
• Ras, huidskleur of nationaliteit
• Geslacht of genderidentiteit
• Seksuele geaardheid
• Leeftijd
• Religie of levensovertuiging
• Handicap of chronische ziekte
• Politieke voorkeur

7.3 Intimidatie, pesterijen en seksuele intimidatie worden niet getolereerd.

7.4 Klachten over discriminatie of intimidatie worden serieus genomen en vertrouwelijk behandeld.`,
  },
  {
    title: '8. Gebruik van bedrijfsmiddelen',
    content: `8.1 Bedrijfsmiddelen mogen alleen worden gebruikt voor zakelijke doeleinden, tenzij beperkt privégebruik is toegestaan.

8.2 Dit omvat:
• Computers en IT-systemen
• Telefoons en communicatiemiddelen
• Voertuigen en apparatuur
• Faciliteiten en kantoorruimte

8.3 Medewerkers zijn verantwoordelijk voor het zorgvuldig gebruik en beheer van bedrijfsmiddelen.`,
  },
  {
    title: '9. Sociale media en communicatie',
    content: `9.1 Bij het gebruik van sociale media dienen medewerkers:
• Duidelijk te zijn over of zij namens de organisatie of privé communiceren
• Geen vertrouwelijke bedrijfsinformatie te delen
• Respectvol te blijven en de goede naam van de organisatie te beschermen
• Niet te spreken namens de organisatie zonder toestemming

9.2 Bij twijfel moet contact worden opgenomen met de leidinggevende.`,
  },
  {
    title: '10. Naleving van wet- en regelgeving',
    content: `10.1 Alle medewerkers moeten zich houden aan:
• Nederlandse en Belgische wet- en regelgeving
• Branchespecifieke regelgeving
• Interne bedrijfsregels en procedures
• Ethische codes en richtlijnen

10.2 Bij twijfel over de naleving moet advies worden ingewonnen.`,
  },
  {
    title: '11. AVG/GDPR en privacy',
    content: `11.1 We respecteren de privacy van klanten, medewerkers en andere betrokkenen.

11.2 Persoonsgegeven worden verwerkt in overeenstemming met de AVG/GDPR.

11.3 Medewerkers die toegang hebben tot persoonsgegevens moeten:
• Alleen toegang hebben voor zakelijke doeleinden
• Persoonsgegevens vertrouwelijk behandelen
• Zich houden aan de privacyregels
• Beveiligingsincidenten melden`,
  },
  {
    title: '12. Meldregeling (Klokkenluidersregeling)',
    content: `12.1 We moedigen medewerkers aan om (vermoedens van) misstanden te melden.

12.2 Meldingen kunnen worden gedaan bij:
• De directe leidinggevende
• De HR-afdeling
• Een onafhankelijke vertrouwenspersoon
• Een externe meldlijn (indien beschikbaar)

12.3 Melders worden beschermd tegen represailles.

12.4 Alle meldingen worden vertrouwelijk behandeld en serieus onderzocht.

12.5 Malafide meldingen zijn niet toegestaan en kunnen gevolgen hebben.`,
  },
  {
    title: '13. Gevolgen van overtreding',
    content: `13.1 Overtredingen van dit Integriteitsbeleid kunnen leiden tot:
• Een waarschuwing
• Een disciplinaire maatregel
• Ontslag
• Juridische stappen
• Aangifte bij de politie (bij strafbare feiten)

13.2 De aard en ernst van de overtreding bepalen de te nemen maatregel.

13.3 Bij ernstige overtredingen kan direct tot ontslag worden overgegaan.`,
  },
  {
    title: '14. Training en bewustwording',
    content: `14.1 Alle medewerkers worden geïnformeerd over dit Integriteitsbeleid bij indiensttreding.

14.2 Regelmatig worden trainingen en workshops georganiseerd over integriteit en ethiek.

14.3 Het Integriteitsbeleid is beschikbaar voor alle medewerkers via het intranet en wordt actief gecommuniceerd.`,
  },
  {
    title: '15. Verantwoordelijkheid en toezicht',
    content: `15.1 De directie is eindverantwoordelijk voor de naleving van dit Integriteitsbeleid.

15.2 Leidinggevenden zijn verantwoordelijk voor:
• Het uitdragen van integriteitsnormen
• Het geven van het goede voorbeeld
• Het aanspreken van medewerkers op gedrag
• Het signaleren van mogelijke overtredingen

15.3 Een Integriteitsfunctionaris houdt toezicht op de naleving en is aanspreekpunt voor vragen.`,
  },
  {
    title: '16. Evaluatie en aanpassing',
    content: `16.1 Dit Integriteitsbeleid wordt jaarlijks geëvalueerd en waar nodig aangepast.

16.2 Wijzigingen worden gecommuniceerd aan alle medewerkers.

16.3 Bij ingrijpende wijzigingen in wet- en regelgeving wordt het beleid tussentijds aangepast.`,
  },
  {
    title: '17. Slotbepalingen',
    content: `17.1 Dit Integriteitsbeleid is vastgesteld op ${new Date().toLocaleDateString('nl-BE')}.

17.2 Alle medewerkers verklaren kennis te hebben genomen van dit Integriteitsbeleid en zich hieraan te houden.

17.3 Voor vragen over dit beleid kunt u contact opnemen met:
Paeps Steven
E-mail: contact@tspeelfabrik.be
Telefoon: +32 474 68 10 52`,
  },
]
</script>

<template>
  <VContainer>
    <VCard
      class="pa-4 mx-auto"
      max-width="1200"
    >
      <VCardText>
        <VContainer>
          <VAlert
            type="info"
            variant="tonal"
            class="mb-6"
          >
            Dit Integriteitsbeleid beschrijft de normen en waarden die wij hanteren en die we van al onze medewerkers en partners verwachten.
          </VAlert>

          <div
            v-for="(section, index) in sections"
            :key="index"
            class="mb-6"
          >
            <h2 class="text-h6 mb-3">
              {{ section.title }}
            </h2>
            <p
              class="text-body-1"
              style="white-space: pre-line;"
            >
              {{ section.content }}
            </p>
          </div>

          <VDivider class="my-6" />

          <div class="text-center">
            <VBtn
              to="/"
              color="primary"
            >
              Terug naar Home
            </VBtn>
          </div>
        </VContainer>
      </VCardText>
    </VCard>
  </VContainer>
</template>
